import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICouponIssuer } from "src/models/Offers/Coupon.models";

interface CouponIssuerState {
  couponIssuers: ICouponIssuer[];
  couponIssuerToEdit: ICouponIssuer | null;
}

const initialState: CouponIssuerState = {
  couponIssuers: [],
  couponIssuerToEdit: null,
};

const CouponIssuerSlice = createSlice({
  name: "CouponIssuer",
  initialState,
  reducers: {
    setCouponIssuerList: (state, action: PayloadAction<ICouponIssuer[]>) => {
      state.couponIssuers = action.payload;
    },
    concatListCouponIssuer: (
      state: CouponIssuerState,
      action: PayloadAction<ICouponIssuer[]>
    ) => {
      state.couponIssuers = [...state.couponIssuers.concat(action.payload)];
    },
    setCouponIssuerToEdit: (
      state,
      action: PayloadAction<ICouponIssuer | null>
    ) => {
      state.couponIssuerToEdit = action.payload;
    },
    addCouponIssuer: (state, action: PayloadAction<ICouponIssuer>) => {
      state.couponIssuers.push(action.payload);
    },
    updateCouponIssuer: (state, action: PayloadAction<ICouponIssuer>) => {
      let itemIndex = state.couponIssuers.findIndex(
        item => item.couponIssuerId === action.payload.couponIssuerId
      );
      if (itemIndex !== -1) state.couponIssuers[itemIndex] = action.payload;
    },
    deleteCouponIssuer: (state, action: PayloadAction<number>) => {
      const newArray = state.couponIssuers.filter(
        item => item.couponIssuerId !== action.payload
      );
      state.couponIssuers = newArray;
    },
  },
});

export const {
  setCouponIssuerList,
  concatListCouponIssuer,
  setCouponIssuerToEdit,
  addCouponIssuer,
  updateCouponIssuer,
  deleteCouponIssuer,
} = CouponIssuerSlice.actions;

export default CouponIssuerSlice.reducer;
